export const featuresFlags = {
  estimateImporter: process.env.REACT_APP_FEATURE_ESTIMATE_IMPORTER === 'true',
}
